import Group_1 from '../../resources/image/Group_1.png';
import Group_3 from '../../resources/image/Group_3.png';
import Group_4 from '../../resources/image/Group_4.png';
import Group_6 from '../../resources/image/Group_6.png';


const myFake = [
    {
        firstPart:'Reduce congestion and expand road capacity',
        secondPart:'without pouring new concrete',
        image_link: Group_1,
        number:'one',
    },
    {
        firstPart:'Decrease travel times and increase trip reliability',
        secondPart:'even for regular lanes',
        image_link: Group_3,
        number:'two',
    },
    {
        firstPart:'tripling the travel options for drivers',
        secondPart:'from “roll the dice” to (1) “roll the dice” or (2) “pay for a fast, reliable commute” or (3) “carpool for a fast, reliable commute”',
        image_link: Group_4,
        number:'three',
    },
    {
        firstPart:'vast monetization of road assets',
        secondPart:'and as byproduct',
        image_link: Group_6,
        number:'four',
    }
];

export default myFake;